@if (rows?.length === 0) {<p class="small text-muted font-italic fadeIn">{{ 'COMMON.EMPTY' | translate }}</p>}